import React from 'react';
import styles from './hero.module.scss';

export default ({ children }) =>
  <div className={['row', 'align-middle', styles.hero].join(' ')}>
    <div className="small-10 small-offset-1 large-12 large-offset-0 columns">
      {children}
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/components/hero.js